import { render, staticRenderFns } from "./SchattingListView.vue?vue&type=template&id=d3c21ea4"
import script from "./SchattingListView.vue?vue&type=script&lang=js"
export * from "./SchattingListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports